/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";

class CompoundReports extends Component {
  state = {
    data: {
      compoundId: "",
      ArTitle: "",
      EnTitle: "",
      KuTitle: "",
      ArBody: "",
      EnBody: "",
      KuBody: "",
      file: null,
    },

    dataUrl: "/api/data/GetCompoundReportsList",
    singleItemUrl: "/api/data/GetCompoundReport",
    addUrl: "/api/data/AddCompoundReport",
    editUrl: "/api/data/EditCompoundReport",
    deleteUrl: "/api/data/DeleteCompoundReport",

    inEditMode: false,
    inModalMode: false,
    modalWidth: "55vw",

    editEntityId: 0,

    filterCompoundId: "",
    compoundsDropdown: [],

    tableData: [],
  };

  componentDidMount() {
    this.getData();
    this.getCompoundsDropdown();
  }

  getCompoundsDropdown() {
    post("/api/data/GetAllCompoundsDropdown", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ compoundsDropdown: apiResponse.data.respData.data });
      }
    );
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
    });

    this.getData();
  }

  getData() {
    post(
      this.state.dataUrl,
      { compoundId: this.state.filterCompoundId || 0 },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({ tableData: apiResponse.data.respData.data });
    });
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      const record = apiResponse.data.respData.data[0];
      var data = this.state.data;

      data["compoundId"] = record.COMPOUND_ID;
      data["ArTitle"] = record.AR_TITLE ?? "";
      data["EnTitle"] = record.EN_TITLE ?? "";
      data["KuTitle"] = record.KU_TITLE ?? "";
      data["ArBody"] = record.AR_BODY ?? "";
      data["EnBody"] = record.EN_BODY ?? "";
      data["KuBody"] = record.KU_BODY ?? "";
      data["file"] = null;

      this.setState({ data: data, editEntityId: record.ID });
    });
  }

  handleDelete(row) {
    confirmAlert({
      title: this.props.t("dialog.deleteTitle"),
      message: this.props.t("dialog.deleteConfirm"),
      buttons: [
        {
          label: this.props.t("btn.yes"),
          onClick: () => {
            post(
              this.state.deleteUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        { label: this.props.t("btn.cancel"), onClick: () => null },
      ],
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }

    // The image goes up as multipart alongside the JSON payload. Leaving it out on
    // edit keeps the image already stored.
    const data = new FormData();
    if (this.state.data.file) {
      data.append("File", this.state.data.file, this.state.data.file.name);
    }
    data.append("requestData", JSON.stringify(submitData));

    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      data,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  getColumns() {
    const { t } = this.props;
    return [
      { id: 1, label: t("col.id"), field: "ID", width: "80px" },
      { id: 2, label: t("col.compound"), field: "COMPOUND_NAME" },
      { id: 3, label: t("col.arabicTitle"), field: "AR_TITLE" },
      { id: 4, label: t("col.englishTitle"), field: "EN_TITLE" },
      { id: 5, label: t("col.kurdishTitle"), field: "KU_TITLE" },
      {
        id: 6,
        label: t("col.image"),
        field: "ATTACHMENT",
        width: "110px",
        cellRenderer: ({ data }) =>
          data.ATTACHMENT ? (
            <a href={data.ATTACHMENT} target="_blank" rel="noopener noreferrer">
              {t("cr.viewImage")}
            </a>
          ) : (
            <span style={{ color: "#999" }}>{t("cr.noImage")}</span>
          ),
      },
      { id: 7, label: t("col.insertDate"), field: "INSERT_DATE" },
      {
        id: 8,
        label: t("col.actions"),
        field: "SYS_ACTIONS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => (
          <div id="outer">
            {sysJwt.isAuthorized(["CB9D"]) && (
              <div className="inner" title="Edit">
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() => {
                    this.getEditFormData(data).then(() => {
                      this.setState({ inEditMode: true });
                      this.showForm();
                    });
                  }}
                >
                  <i className="fa fa-edit" />
                </button>
              </div>
            )}
            {sysJwt.isAuthorized(["CB9E"]) && (
              <div className="inner" title="Delete">
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() => this.handleDelete(data)}
                >
                  <i className="fa fa-trash" />
                </button>
              </div>
            )}
          </div>
        ),
      },
    ];
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.compoundReports")}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB9C"]) && (
              <Button
                label={t("pages.addCompoundReport")}
                icon="fa fa-plus"
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        {/* Filter bar */}
        <div className="page-filter-bar">
          <span className="filter-label">{t("filter.compound")}:</span>
          <Dropdown
            value={this.state.filterCompoundId}
            options={this.state.compoundsDropdown}
            showClear
            filter
            onChange={(e) =>
              this.setState({ filterCompoundId: e.value }, () => this.getData())
            }
            placeholder={t("filter.allCompounds")}
          />
          <Button
            label={t("filter.clear")}
            icon="fa fa-eraser"
            className="p-button-rounded p-button-secondary"
            disabled={this.props.isLoading}
            onClick={() =>
              this.setState({ filterCompoundId: "" }, () => this.getData())
            }
          />
        </div>
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={() => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode ? t("dialog.editTitle") : t("dialog.addTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={this.state.inEditMode ? t("btn.edit") : t("btn.add")}
                icon={this.state.inEditMode ? "fa fa-edit" : "fa fa-plus"}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          {this.state.inEditMode && (
            <div style={{ marginBottom: "10px", padding: "6px 10px", background: "#e2e3e5", color: "#383d41", borderRadius: "4px", fontSize: "12px" }}>
              {t("cr.imageKeepHint")}
            </div>
          )}
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "dropdown",
                id: "compoundId",
                label: t("col.compound"),
                options: this.state.compoundsDropdown,
                disabled: false,
              },
              { type: "text", id: "ArTitle", label: t("col.arabicTitle"), disabled: false },
              { type: "text", id: "EnTitle", label: t("col.englishTitle"), disabled: false },
              { type: "text", id: "KuTitle", label: t("col.kurdishTitle"), disabled: false },
              { type: "textarea", id: "ArBody", label: t("cr.arabicBody"), rows: 5, disabled: false },
              { type: "textarea", id: "EnBody", label: t("cr.englishBody"), rows: 5, disabled: false },
              { type: "textarea", id: "KuBody", label: t("cr.kurdishBody"), rows: 5, disabled: false },
              { type: "fileupload", id: "file", label: t("col.image"), disabled: false },
            ]}
          />
        </Dialog>
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(CompoundReports);
